import { NavLink } from "react-router-dom";
import { AGENT_RESPONSE_STEPS } from "../../js/utils/agentResponseOptions";
import { useDesk } from "../../js/hooks/useDesk";
import { toTitleCase } from "../../js/utils/titleCase";

export default function AgentResponseNav({ responseId }) {
  const desk = useDesk();
  return (
    <nav className="agent-response-nav" aria-label="Property response sections">
      <ol className="agent-response-nav-list">
        {AGENT_RESPONSE_STEPS.map((step) => (
          <li key={step.path}>
            <NavLink
              to={desk.responsePath(responseId, step.path)}
              className={({ isActive }) => `agent-response-link${isActive ? " is-active" : ""}`}
            >
              {toTitleCase(step.label)}
            </NavLink>
          </li>
        ))}
      </ol>
    </nav>
  );
}
